// CID Agent PWA API layer
// Module: Branch sales — a Centre Director's branch, read-only.
//
// The server works out the branch from the caller's Centre Director assignment;
// the client never sends a branch it was not given by /performance/scopes.
import client from './client';

/** GET /api/agent/branch-sales [LIST · paginated] ?stage= &search= &agent_id= */
export const listBranchSales = (params = {}, config = {}) => client.get('/api/agent/branch-sales', { params, ...config });

/** GET /api/agent/branch-sales/:id — the sale, read-only. */
export const getBranchSale = (id) => client.get(`/api/agent/branch-sales/${id}`);

/**
 * GET /api/agent/branch-sales/agents — every agent in the CD's branch for the agent
 * picker, inactive ones included (their sales are still in the branch), sorted by
 * name, the caller left out. Rows: { agent_id, name, display_name, ren_no, is_active }.
 */
export async function listBranchAgents() {
  const r = await client.get('/api/agent/branch-sales/agents');
  const rows = r?.data ?? r;
  return Array.isArray(rows) ? rows : [];
}
